import { render, staticRenderFns } from "./settings-organization-utilization.vue?vue&type=template&id=679be025&scoped=true&"
import script from "./settings-organization-utilization.vue?vue&type=script&lang=js&"
export * from "./settings-organization-utilization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679be025",
  null
  
)

export default component.exports